import $ from '../$';
import './each';
$.fn.hide = function () {
    return this.each(function () {
        this.style.display = 'none';
    });
};
